import React, { Component } from 'react';
import {connect} from 'remx';
import ChartMonaResume from '../../../components/Charts/ChartMonaResume';
import Donut from '../../../components/Charts/Donut';

import broker from '../../../utils/broker'
import dataStore from '../../../stores/data';
import _data_pie from '../_data_pie';

class Resume extends Component {

    constructor(props) {
        super(props);
    
        this.options = {

        }
        this.state = {
          reload:false,
          loading: false,
          data_traffic : {},
          chart_pie : [],
          rate: {},
        }
      }

    getDataTrafficDaily(){
        broker.fetchSupport.get(`generate_graphic_daily_resume?id=${this.props.pelanggan_id}`)
        .then(res => {
            const { data } = res;
            if (data) {
                this.setState({data_traffic : data, keterangan : null});

            } else {

            }
        }).catch(err => {
            
        });
    }

    getPie(){
        broker.fetchSupport.get(`generate_graphic_pie_pelanggan?id=${this.props.pelanggan_id}`)
        .then(res => {
            const { data } = res;
            if (data) {
                this.setState({chart_pie : data});

            } else {

            }
        }).catch(err => {
            
        });
    }

    getRate(){
        broker.fetchSupport.get(`get_rate_pelanggan?id=${this.props.pelanggan_id}`)
        .then(res => {
            const { data } = res;
            if (data) {
                this.setState({rate : data.data});

            } else {

            }
        }).catch(err => {
            
        });
    }

    componentDidMount(){
        // this.getDataTrafficDaily();
        // this.getPie();
        // this.getRate();
    }

      componentDidUpdate(prevProps, prevState) {
        if (this.props.pelanggan_id !== prevProps.pelanggan_id) {
            this.getDataTrafficDaily();
            this.getPie();
            this.getRate();
        }
      }

    render(){
        return(
            <div className="content">
                    <div className="row row-xs">
                        <div className="col-sm-6 col-lg-3">
                            <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Average Upload</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{this.state.rate.upload_avg} Mbps</h3>
                                <p className="tx-11 tx-color-03 mg-b-0"><span className="tx-medium tx-success">Rata-rata</span> Tahun ini</p>
                            </div>
                            <div className="chart-three">
                                <div id="flotChart3" className="flot-chart ht-30"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                            <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Max. Upload</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{this.state.rate.upload_max} Mbps</h3>
                                <p className="tx-11 tx-color-03 mg-b-0"><span className="tx-medium tx-danger">Rata-rata</span> Tahun ini</p>
                            </div>
                            <div className="chart-three">
                                <div id="flotChart4" className="flot-chart ht-30"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
                            <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Average Download</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{this.state.rate.download_avg} Mbps</h3>
                                <p className="tx-11 tx-color-03 mg-b-0"><span className="tx-medium tx-danger">Rata-rata</span> Tahun ini</p>
                            </div>
                            <div className="chart-three">
                                <div id="flotChart5" className="flot-chart ht-30"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
                            <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Max. Download</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{this.state.rate.download_max} Mbps</h3>
                                <p className="tx-11 tx-color-03 mg-b-0"><span className="tx-medium tx-success">Rata-rata</span> Tahun ini</p>
                            </div>
                            <div className="chart-three">
                                <div id="flotChart6" className="flot-chart ht-30"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-xs">
                        <div className="col-lg-8 col-xl-7 mg-t-10">
                            <div className="card" style={{height:'400px'}}>
                                <div className="card-header pd-y-20 d-md-flex align-items-center justify-content-between">
                                    <h6 className="mg-b-0">Rata-rata Bandwidth Pekerjaan</h6>
                                </div>
                                <ChartMonaResume data={this.state.data_traffic} keterangan={this.state.keterangan} />
                            </div>
                        </div>
                        {/* <div className="col-lg-8 col-xl-4 mg-t-10">
                            <div className="card" style={{height:'400px'}}>
                                <div className="card-header pd-y-20 d-md-flex align-items-center justify-content-between">
                                    <h6 className="mg-b-0">Pekerjaan Off ({moment().locale('id').format('LLLL')})</h6>
                                </div>
                                
                            </div>
                        </div> */}
                        <div className="col-lg-8 col-xl-5 mg-t-10">
                            <div className="card" style={{height:'400px'}}>
                                <div className="card-header pd-y-20 d-md-flex align-items-center justify-content-between">
                                    <h6 className="mg-b-0">Perbandingan Traffic Success dan Loss</h6>
                                    {/* <h6 className="mg-b-0">Data Pekerjaan Yang Off ({moment().locale('id').format('LLLL')})</h6> */}
                                </div>
                                <Donut data={this.state.chart_pie} height={300}/>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
    }
}


export default connect(mapStateToProps)(Resume);